import Vue from 'vue'
import { exludeEmptyParams } from '../providers/store-parser'
import {
  getQuotings,
  getOcops,
  getOrders,
  orderDownload,
  getProductsInfo,
  getCustomers,
  getSuppliersPaginate,
  getWarehousesPaginate,
  getBrandsPaginate,
  getStaffPaginate,
  productDownload,
  csrDownload
} from '../api'

import {
  routeQUO,
  routeOCOP,
  routeINV,
  routeCN,
  routePO,
  routeBCN,
  routeBL,
  routeTR,
  routeAJ,
  routeInfoPRDC,
  routeInfoCSR,
  routeInfoSPL,
  routeInfoWH,
  routeInfoBRD,
  routeInfoEMPL
} from '../router'

async function _search (context, inputs, api) {
  context.commit('toggleListLoading', true)
  const { page, size } = context.state.meta
  const params = { page, per_page: size }
  Object.assign(params, exludeEmptyParams(inputs))
  const response = await api(params)
  const data = response.data
  context.commit('setTotal', response.meta.total)
  context.commit('setPage', response.meta.current_page)
  context.commit('setPageSize', response.meta.per_page)
  context.commit('setLists', data)

  if (context.state.searchPage === 'Invoice') { // 计算小计
    let subQty = 0
    let subAmt = 0
    data.map(item => {
      subQty += item.qty
      subAmt += item.amount
    })
    context.commit('setListSubtotal', {
      subQty,
      subAmt
    })
  }

  context.commit('toggleIsNew', false)
  context.commit('toggleListLoading')
  return response
}

// here prepare search conditions
// mainly select needed
function _quotingPrepare (state) {
  const { product, csr, brand, category, stockAvl, warehouse, tag4 } = state
  const others = { product, brand, category, stockAvl, warehouse, tag4 }
  if (csr.id) {
    others.csrId = csr.id
  }
  return others
}

function _ocopPrepare (state) {
  const { product, brand, category } = state
  return { product, brand, category }
}

function _ocopResponse (context, data) {
  context.commit('setOcopCsrs', data.csrs)
}

function _invPrepare (state) {
  return {
    type: 'invoice',
    order_type: state.orderType,
    date: state.dateRange,
    dueDate: state.dueDateRange,
    tag: state.tag,
    no: state.no,
    csr: state.csrWord,
    reference: state.reference,
    drafterType: state.drafterType,
    product: state.product,
    warehouse: state.warehouse,
    sortType: state.sortType,
    approver: state.approver,
    deliveryStatus: state.deliveryStatus,
    status: state.status,
    print: state.print,
    xeroSend: state.xeroSend,
    csrOrderStatus: state.csrStatus
  }
}

function _pcPrepare (state) {
  const params = _invPrepare(state)
  params.type = 'purchase'
  params.upstream = state.upstream
  params.deliveryDate = state.deliveryDateRange
  params.closure = state.closure
  return params
}

function _trPrepare (state) {
  const params = _pcPrepare(state)
  params.order_type = 6
  params.inWarehouse = state.inWarehouse
  return params
}

function _ajPrepare (state) {
  const params = _pcPrepare(state)
  params.order_type = 7
  return params
}

function _infoPrdcPrepare (state) {
  return { ...state.baseProduct }
}

function _infoCsrPrepare (state) {
  return { ...state.baseCsr }
}

const emptyTpl = {
  searchPage: '',
  searchApi: {
    prepareCb: null,
    api: null,
    responseCb: null
  },
  orderType: 0,
  // for quotings
  csr: {},
  product: '',
  brand: 0,
  category: 0,
  stockAvl: 0,
  // for inv
  no: '',
  dateRange: '',
  dueDateRange: '',
  deliveryDateRange: '',
  tag: '',
  tag1: '',
  tag2: '',
  tag3: '',
  tag4: '',
  csrWord: '',
  reference: '',
  upstream: '',
  drafterType: '',
  warehouse: '',
  inWarehouse: '',
  sortType: '',
  approver: '',
  deliveryStatus: '',
  status: '',
  print: '',
  xeroSend: '',
  csrStatus: '',
  closure: '',
  lists: [],
  listSubtotal: {
    subQty: 0,
    subAmt: 0
  },
  listLoading: false,
  isNew: true,
  withIndex: false,
  meta: {
    page: 1,
    total: 0,
    size: 20
  },

  baseProduct: {
    name: '',
    category: '',
    brand: '',
    tag1: '',
    tag2: '',
    tag3: '',
    tag4: '',
    createDateRange: '',
    modifyDateRange: '',
    sortType: '',
    xeroSend: ''
  },
  baseCsr: {
    name: '',
    createDateRange: '',
    modifyDateRange: '',
    xeroSend: '',
    priceType: '',
    businessType: '',
    paymentType: '',
    areaType: ''
  },

  ocopCrs: [],
  baseProductSortTypes: [
    { value: 0, label: 'All' },
    { value: 1, label: 'Code from High to Low' },
    { value: 2, label: 'Code from Low to High' },
    { value: 3, label: 'Create Date from New to Old' },
    { value: 4, label: 'Create Date from Old to New' },
    { value: 5, label: 'Modify Date from New to Old' },
    { value: 6, label: 'Modify Date from Old to New' }
  ]
}
export default {
  namespaced: true,
  state: {
    ...emptyTpl
  },
  getters: {
    csrId: state => state.csr.id || '',
    page: state => state.meta.page,
    total: state => state.meta.total,
    pageSize: state => state.meta.size,
    invPageType: (state, getters, rootState) =>
      rootState.orderTypes.filter(o => o.value === 1 || o.value === 2),
    invPageTypeAll: (state, getters) => {
      const types = getters.invPageType.slice()
      types.unshift({ value: '0', label: 'All' })
      return types
    },
    pcPageType: (state, getters, rootState) =>
      rootState.orderTypes.filter(o => o.value === 3),
    blPageType: (state, getters, rootState) =>
      rootState.orderTypes.filter(o => o.value === 4 || o.value === 5),
    blPageTypeAll: (state, getters) => {
      const types = getters.blPageType.slice()
      types.unshift({ value: 0, label: 'All' })
      return types
    },
    invTagsWithAll: (state, getters, rootState, rootGetters) => {
      const tags = rootGetters.invoiceTags.slice()
      tags.unshift({ value: 0, label: 'All' })
      return tags
    },
    purchaseTagsWithAll: (state, getters, rootState, rootGetters) => {
      const tags = rootGetters.purchaseTags.slice()
      tags.unshift({ value: 0, label: 'All' })
      return tags
    },
    drafterTypes: () => {
      return [
        { value: 0, label: 'All' },
        { value: 1, label: 'Staff Service' },
        { value: 2, label: 'Staff Business' },
        { value: 3, label: 'Customer Self' }
      ]
    },
    sortTypes: () => {
      return [
        { value: 0, label: 'All' },
        { value: 1, label: 'Number from High to Low' },
        { value: 2, label: 'Number from Low to High' },
        { value: 3, label: 'Amount from High to Low' },
        { value: 4, label: 'Amount from Low to High' },
        { value: 5, label: 'Due Date from New to Old' },
        { value: 6, label: 'Due Date from Old to New' }
      ]
    },
    deliStatusTypes: () => {
      return [
        { value: 0, label: 'All' },
        { value: 'deliver preparing', label: 'In Preparing' }, // 此选项暂时特殊处理一下
        { value: 1, label: 'Ready to Dispatch/Pickup' },
        { value: 2, label: 'Delivering/Picking' },
        { value: 3, label: 'Delivered/Picked-up' },
        { value: 99, label: 'Cancelled' }
      ]
    },
    prints: () => {
      return [
        { value: 0, label: 'All' },
        { value: 1, label: 'PRINTED' },
        { value: 2, label: 'Unprinted' }
      ]
    },
    xeroSends: () => {
      return [
        { value: 0, label: 'All' },
        { value: 1, label: 'Sent' },
        { value: 2, label: 'Unsent' }
      ]
    },
    csrOrderStatus: () => {
      return [
        { value: 0, label: 'All' },
        { value: 1, label: 'Cancel by Staff' },
        { value: 2, label: 'Cancel by CSR' }
      ]
    },
    approvers: (state, getters, rootState, rootGetters) => {
      const bd = rootGetters.bd.slice()
      bd.unshift({ value: 0, label: 'All' })
      return bd
    },

    orderStatus: (state, getters, rootState) => {
      const status = rootState.orderStatus.filter(s => s.value !== 4)
      status.unshift({ value: 0, label: 'All' })
      return status
    },
    closures: () => {
      return [
        { value: 0, label: 'All' },
        { value: 1, label: 'Closed' },
        { value: 2, label: 'Unclosed' }
      ]
    },
    orderTypeIcon: (state, getters, rootState, rootGetters) => type =>
      rootGetters['prefs/orderTypeIcon'](type)
  },
  mutations: {
    init: state => {
      // deep copy tpl here
      const tpl = JSON.parse(JSON.stringify(emptyTpl))
      for (const prop in state) {
        Vue.set(state, prop, tpl[prop])
      }
    },
    setCsr: (state, csr) => (state.csr = csr),
    setProduct: (state, product) => (state.product = product),
    setBrand: (state, brand) => (state.brand = brand),
    setStockAvl: (state, stockAvl) => (state.stockAvl = stockAvl),
    setCategory: (state, category) => (state.category = category),
    setLists: (state, lists) => (state.lists = lists),
    setListSubtotal: (state, data) => (state.listSubtotal = data),
    toggleListLoading: (state, status = false) => (state.listLoading = status),
    setPage: (state, page) => (state.meta.page = Number(page)),
    setTotal: (state, total) => (state.meta.total = Number(total)),
    setPageSize: (state, size) => (state.meta.size = Number(size)),
    toggleIsNew: (state, status) => (state.isNew = !!status),
    setOcopCsrs: (state, csrs) => (state.ocopCrs = csrs),
    setSearchPage: (state, routeName) => (state.searchPage = routeName),
    setSearchApi: (state, { prepare, api, response }) => {
      state.searchApi.prepareCb = prepare
      state.searchApi.api = api
      state.searchApi.responseCb = response
    },
    setOrderType: (state, type) => (state.orderType = type),
    setDateRange: (state, range) => (state.dateRange = range),
    setDueDateRange: (state, range) => (state.dueDateRange = range),
    setDeliveryDateRange: (state, range) => (state.deliveryDateRange = range),
    setDeliveryStatus: (state, status) => (state.deliveryStatus = status),
    setTag: (state, word) => (state.tag = word),
    setTag1: (state, word) => (state.tag1 = word),
    setTag2: (state, word) => (state.tag2 = word),
    setTag3: (state, word) => (state.tag3 = word),
    setTag4: (state, word) => (state.tag4 = word),
    setCsrWord: (state, word) => (state.csrWord = word),
    setReference: (state, word) => (state.reference = word),
    // setDrafterType: (state, word) => (state.drafterType = word),
    setDrafterType: (state, word) => {
      state.drafterType = word
    },
    setNo: (state, word) => (state.no = word),
    setWarehouse: (state, word) => (state.warehouse = word),
    setInWarehouse: (state, word) => (state.inWarehouse = word),
    setUpstream: (state, word) => (state.upstream = word),
    setWithIndex: (state, status = false) => (state.withIndex = status),
    setSortType: (state, word) => (state.sortType = word),
    setApprover: (state, word) => (state.approver = word),
    setStatus: (state, word) => (state.status = word),
    setPrint: (state, word) => (state.print = word),
    setXero: (state, word) => (state.xeroSend = word),
    setCsrStatus: (state, word) => (state.csrStatus = word),
    setClosure: (state, word) => (state.closure = word),
    setPaymentType: (state, paymentType) => (state.paymentType = paymentType),
    setBaseProductName: (state, code = '') => (state.baseProduct.name = code),
    setBaseProductCategory: (state, code = '') =>
      (state.baseProduct.category = code),
    setBaseProductBrand: (state, code = '') => (state.baseProduct.brand = code),
    setBaseProductTag1: (state, code = '') => (state.baseProduct.tag1 = code),
    setBaseProductTag2: (state, code = '') => (state.baseProduct.tag2 = code),
    setBaseProductTag3: (state, code = '') => (state.baseProduct.tag3 = code),
    setBaseProductTag4: (state, code = '') => (state.baseProduct.tag4 = code),
    setBaseProductCreateRange: (state, code = '') =>
      (state.baseProduct.createDateRange = code),
    setBaseProductModifyRange: (state, code = '') =>
      (state.baseProduct.modifyDateRange = code),
    setBaseProductSortType: (state, code = '') =>
      (state.baseProduct.sortType = code),
    setBaseProductXeroSend: (state, code = '') =>
      (state.baseProduct.xeroSend = code),
    setBaseCsrName: (state, code = '') => (state.baseCsr.name = code),
    setBaseCsrCreateRange: (state, code = '') =>
      (state.baseCsr.createDateRange = code),
    setBaseCsrModifyRange: (state, code = '') =>
      (state.baseCsr.modifyDateRange = code),
    setBaseCsrXeroSend: (state, code = '') => (state.baseCsr.xeroSend = code),
    setBaseCsrPriceType: (state, code = '') => (state.baseCsr.priceType = code),
    setBaseCsrBusinessType: (state, code = '') =>
      (state.baseCsr.businessType = code),
    setBaseCsrPaymentType: (state, code = '') =>
      (state.baseCsr.paymentType = code),
    setBaseCsrAreaType: (state, code = '') => {
      state.baseCsr.areaType = code
    }
  },
  actions: {
    search: async context => {
      const params = context.state.searchApi.prepareCb(context.state)
      const api = context.state.searchApi.api
      const cb = context.state.searchApi.responseCb
      const data = await _search(context, params, api)

      if (cb) {
        cb(context, data)
      }
    },

    export: context => {
      const params = {}
      params.format = 'xlsx'
      Object.assign(
        params,
        exludeEmptyParams(context.state.searchApi.prepareCb(context.state))
      )
      const fileName = 'orders.xlsx'
      orderDownload(params, fileName)
    },
    exportBaseInfo: (context, routeName) => {
      const params = {}
      params.format = 'xlsx'
      Object.assign(
        params,
        exludeEmptyParams(context.state.searchApi.prepareCb(context.state))
      )

      if (routeName === routeInfoPRDC) {
        const fileName = 'products.xlsx'
        productDownload(params, fileName)
      } else {
        const fileName = 'csr.xlsx'
        csrDownload(params, fileName)
      }
    },

    changePage: (context, page) => {
      context.commit('setPage', page)
      context.dispatch('search')
    },
    changePageSize: (context, size) => {
      context.commit('setPage', 1)
      context.commit('setPageSize', size)
      context.dispatch('search')
    },
    initSearch: (context, routeName) => {
      context.commit('init')
      context.commit('setSearchPage', routeName)
      switch (routeName) {
        case routeQUO:
          context.commit('config/setQuotings', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _quotingPrepare,
            api: getQuotings
          })
          break
        case routeOCOP:
          context.commit('config/setOcop', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _ocopPrepare,
            api: getOcops,
            response: _ocopResponse
          })
          break
        case routeINV:
          context.commit('setWithIndex', true)
          context.commit('config/setInv', 'search', { root: true })
          context.commit('setPageSize', 100)
          context.commit('setSearchApi', {
            prepare: _invPrepare,
            api: getOrders
          })
          break
        case routeCN:
          context.commit('setWithIndex', true)
          context.commit('config/setCN', 'search', { root: true })
          context.commit('setPageSize', 100)
          context.commit('setSearchApi', {
            prepare: _invPrepare,
            api: getOrders
          })
          break
        case routePO:
          context.commit('setWithIndex', true)
          context.commit('config/setPO', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _pcPrepare,
            api: getOrders
          })
          break
        case routeBL:
          context.commit('setWithIndex', true)
          context.commit('config/setBL', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _pcPrepare,
            api: getOrders
          })
          break
        case routeBCN:
          context.commit('setWithIndex', true)
          context.commit('config/setBCN', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _pcPrepare,
            api: getOrders
          })
          break
        case routeTR:
          context.commit('setWithIndex', true)
          context.commit('config/setTR', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _trPrepare,
            api: getOrders
          })
          break
        case routeAJ:
          context.commit('setWithIndex', true)
          context.commit('config/setAJ', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _ajPrepare,
            api: getOrders
          })
          break
        case routeInfoPRDC:
          context.commit('setWithIndex', true)
          context.commit('config/setInfoPrdc', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _infoPrdcPrepare,
            api: getProductsInfo
          })
          break
        case routeInfoCSR:
          context.commit('setWithIndex', true)
          context.commit('config/setInfoCsr', 'search', { root: true })
          context.commit('setSearchApi', {
            prepare: _infoCsrPrepare,
            api: getCustomers
          })
          break
        case routeInfoSPL:
          context.commit('setWithIndex', true)
          context.commit('config/setInfoSpl', 'search', { root: true })
          context.commit('setSearchApi', {
            api: getSuppliersPaginate,
            prepare: () => {}
          })
          break
        case routeInfoWH:
          context.commit('setWithIndex', true)
          context.commit('config/setInfoWh', 'search', { root: true })
          context.commit('setSearchApi', {
            api: getWarehousesPaginate,
            prepare: () => {}
          })
          break
        case routeInfoBRD:
          context.commit('setWithIndex', true)
          context.commit('config/setInfoBr', 'search', { root: true })
          context.commit('setSearchApi', {
            api: getBrandsPaginate,
            prepare: () => {}
          })
          break
        case routeInfoEMPL:
          context.commit('setWithIndex', true)
          context.commit('config/setInfoEmpl', 'search', { root: true })
          context.commit('setSearchApi', {
            api: getStaffPaginate,
            prepare: () => {}
          })
          break
      }
    }
  }
}
